import React, { useState } from 'react';
import { Card, Modal } from 'antd';
import RegistrationButton from './RegistrationButton';
import TimelineComp from './TimelineComp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faFlag, faGear, faLocationDot, faPenToSquare, faRobot, faXmarkSquare } from '@fortawesome/free-solid-svg-icons';

const { Meta } = Card;

const Cards = () => {
    const [activeModal, setActiveModal] = useState<number | null>(null);

    const handleSeeDetail = (id: number) => () => {
        setActiveModal(id);
    };

    const handleCloseModal = () => {
        setActiveModal(null);
    };
    return (
        <>
            <Card
                hoverable
                cover={<img alt="card-programming" src="/images/card/card-programming.webp" />}
                style={{ width: 300, display: 'flex', flexDirection: 'column' }}
            >
                <div style={{ flexGrow: 1 }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Software Programming Category</span>} />
                    <p className='text-sm text-gray-400 mt-2'>Python Coding, Individual </p>
                    <p className='text-sm text-gray-400 font-bold mt-1'>Rp150.000</p>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-16">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(1)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Software Programming Category</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 1}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-2 md:ml-2 lg:ml-4'>Individual</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-4 md:ml-2 md:w-1/2 '>
                            <ol>
                                <li>Junior High School</li>
                                <li>Senior High School</li>
                            </ol>
                        </span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-0'>Python language competition based on 3 level question quiz are easy, intermediate, challenging</span>
                    </div>

                    <div className="flex">
                        <span className='text-gray-400 mr-6 lg:mr-12 md:mr-16'>Example Question</span>
                        <span>
                            <ul className="list-disc space-y-1">
                                <li>
                                    <a href='https://ausrobotics.org/wp-content/uploads/2023/08/coding-examples_junior.pdf' target="_blank" rel="noopener noreferrer" className='underline font-bold'>
                                        Junior High School Question
                                    </a>
                                </li>
                                <li>
                                    <a href='https://ausrobotics.org/wp-content/uploads/2023/08/coding-examples_senior.pdf' target="_blank" rel="noopener noreferrer" className='underline font-bold'>
                                        Senior High School Question
                                    </a>
                                </li>
                            </ul>
                        </span>
                    </div>

                    <div className="flex">
                        <span className='text-gray-400 mr-5 lg:mr-5 md:mr-16 flex items-start'>Assessment Criteria</span>
                        <span className='w-full lg:w-1/2  md:ml-0'>
                            <p className='mb-1'>Score based</p>
                            <ol className="list-decimal pl-5 space-y-1 ">
                                <li>Up to 4 points for correctness</li>
                                <li>Up to 2 points for comments</li>
                                <li>Up to 4 points for algorithmic efficiency</li>
                            </ol>
                        </span>
                    </div>
                </div>
                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'Onsite at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Computer lab at Universitas Kristen Krida Wacana</p>
                </div>

                {/* <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faGear} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Preliminary Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>Software Programming Preliminary Round at online Zoom Meetings and final competition at UKRIDA (20 best participant)</li>
                    <li>Participants complete as many questions as possible in 2 hours</li>
                    <li>Participants will be given 1 application URL</li>
                    <li>Computer/laptop minimum spesification are Google Chrome and Windows i5, RAM 4-8 GB</li>
                </ol> */}
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Mechanism </p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>Participants complete as many questions as possible in 2 hours</li>
                </ol>
            </Modal>

            <Card
                hoverable
                cover={<img alt="card-symposium" src="/images/card/card-symposium.webp" />}
                style={{ width: 300, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            >
                <div style={{ flexGrow: 1 }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Meta title={<span style={{ whiteSpace: 'normal' }}>Student Symposium Research Paper</span>} />
                    </div>
                    <p className='text-sm text-gray-400 mt-2'>Presentation Category, Team (max 4 Person)</p>
                    <p className='text-sm text-gray-400 font-bold mt-1'>Rp600.000</p>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-6">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(2)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Student Symposium Research Paper</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 2}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-2 md:ml-2 lg:ml-4'>1 team of max 4 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-4 md:ml-2 md:w-1/2 '>High School (Mix Junior and Senior)</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-0'>Each team will research and develop a technological solution that solves a problem related to Covid19 or one of the 17 UN sustainable development goals.</span>
                    </div>

                    <div className="flex">
                        <span className='text-gray-400 mr-5 lg:mr-5 md:mr-16 flex items-start'>Assessment Criteria</span>
                        <span className='w-full lg:w-1/2 md:ml-0'>
                            <ol className="list-decimal pl-5 space-y-1 ">
                                <li>Up to 5 points for content</li>
                                <li>Up to 3 points for presentation skills</li>
                                <li>Up to 2 points for handling Q&A</li>
                            </ol>
                        </span>
                    </div>
                </div>
                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'Online Submission of Video and Paper', 'Onsite at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '28 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'orange', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Online Submission and Universitas Kristen Krida Wacana</p>
                </div>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faGear} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Online Submission</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>Students make and upload a (max. 5 minutes) YouTube video that contains a verbal presentation, and submit a research paper for publication in English language. This challenge may or may not have to demonstrate a physical model or prototype</li>
                    <li>The research outcomes should be submitted in a research paper following the
                        <a href="https://docs.google.com/document/d/1TVC8s1HRcA6bDz9HGgMJYH6rMpN9SGj0/edit?usp=sharing&ouid=110635284425180614318&rtpof=true&sd=true"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='ml-1 underline'
                        >
                            WIT publication format
                        </a>
                    </li>
                    <li>Please submit the video link and research paper on the 28th September 2024 in
                        <a href="https://link.accelist.com/Symposium"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='ml-1 underline'
                        >
                            https://link.accelist.com/Symposium
                        </a>
                    </li>
                </ol>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Student Symposium Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>Teams will present in 10 minutes about their research through a series of slides and a talk that details their research into the problem, the problem-solving process, and the final results in english language</li>
                </ol>
            </Modal>

            <Card
                hoverable
                cover={<img alt="card-innovative" src="/images/card/card-innovative.webp" />}
                style={{ width: 300, display: 'flex', flexDirection: 'column' }}
            >
                <div style={{ flexGrow: 1 }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Innovative Technology Challenge</span>} />
                    <p className='text-sm text-gray-400 mt-2'>Presentation Category, Team (max 4 Person)</p>
                    <p className='text-sm text-gray-400 font-bold mt-1'>Rp500.000 - Rp600.000</p>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-12">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(3)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Innovative Technology Challenge</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 3}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-3 md:ml-3 lg:ml-5'>1 team of max 4 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-6 lg:ml-4 md:ml-4 md:w-1/2 '>
                            <ol>
                                <li>Elementary School</li>
                                <li>High School (Mix Junior and Senior)</li>
                            </ol>
                        </span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <div className="flex flex-col ml-2 md:ml-3 lg:ml-9">
                            <span className='w-full lg:w-1/2 ml-2 md:ml-1 lg:ml-2 mb-2 leading-relaxed'>Each team will build a technological solution (robot, unmanned aerial vehicle, smart house, etc.). The technological solution will demonstrate the innovative design and application for some problem related to:</span>
                            <span className='w-full lg:w-1/2 md:ml-0 mb-2'>
                                <ol className="list-decimal pl-5 space-y-1 ml-2 lg:ml-3">
                                    <li>Food security, improved nutrition, and promote sustainable agriculture</li>
                                    <li>Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation</li>
                                    <li>Availability and sustainable management of water and sanitation</li>
                                    <li>Urgent action to combat climate change and its impacts</li>
                                </ol>
                            </span>
                            <span className='w-full lg:w-1/2 ml-2 md:ml-1 lg:ml-3'>Note: Don’t use any dangerous materials, such as water, fire, or chemical substances for the demonstration</span>
                        </div>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-5 lg:mr-4 md:mr-16'>Assessment Criteria</span>
                        <span className='w-full lg:w-1/2 md:ml-0'>
                            <ol className="list-decimal pl-5 space-y-1 ">
                                <li>Creativity of the Concept (30%)</li>
                                <li>Significance of the Technology (30%)</li>
                                <li>Completeness (20%)</li>
                                <li>Presentation (20%)</li>
                                <li>The challenge will be judged based on the level of innovation, use of technology and how well the solution meets the needs of the problem. The presentation may involve.</li>
                            </ol>
                        </span>
                    </div>
                </div>
                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'IIT Challenge at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Universitas Kristen Krida Wacana</p>
                </div>
                {/* 
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faGear} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Online Submission</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>The team must make and upload a (max 2min) YouTube video about your invention. The video should explain the software and hardware components of your invention and demonstrate how it works</li>
                    <li>Please submit the video link and research paper on the 14th September in
                        <a href="https://link.accelist.com/innovative"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='ml-1 underline'
                        >
                            https://link.accelist.com/innovative
                        </a>
                    </li>
                </ol> */}

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Innovative Technology Challenge Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>The team will have to submit the theory test</li>
                    <li>The team will have to <span className='font-bold'>assembled your invention from zero at onsite (Bring the unassembled invention)</span> and answer questions about your design from referees</li>
                </ol>
                <div className="flex items-center mb-1 font-medium">
                    <div className="flex flex-col w-full">
                        <p className='mb-6 md:mb-4 text-center text-2xl md:text-4xl text-defaultBlue font-bold'>Tips and Trick</p>
                        <p className='text-left'>Getting Started:</p>
                    </div>
                </div>
                <div className="flex flex-col ml-2 mb-4 text-gray-500">
                    <p>If you have never built a technology solution before, here’s how to get started in this competition:</p>
                    <ol className="list-disc pl-4 mb-1 ml-1 mt-1 space-y-1">
                        <li>Identify a simple problem in real life that could be solved using a robot or dedicated device.</li>
                        <li>Research the types of robots (any brand) or the types of technologies (Arduino, Raspberry Pi, Sensors, and Actuators) that might be useful in solving the problem. Also explore the programming languages that would be useful, and the type of programming needed to control these technologies.</li>
                        <li>Purchase the necessary components and software and get started constructing and trying various algorithms to enable your robot or technology to perform its task.</li>
                    </ol>
                    <p>Note: The robot or technology does not need to be completely unique but must be completely constructed by student teams with strictly limited adult support leading up to the challenge.</p>
                </div>

                <div className="flex items-center mb-1 font-medium">
                    <p>Already Experienced:</p>
                </div>
                <div className="flex flex-col ml-2 text-gray-500 mb-8">
                    <p>If you already developed some great inventions, robots, or technological solutions before, here’s how you can become more competitive in this competition:</p>
                    <ol className="list-disc pl-4 mb-1 ml-1 mt-1 space-y-1">
                        <li>Optimize your programming to perform the task more efficiently (reducing costs, reducing processing time, introducing connectivity between devices or the Internet, etc.).</li>
                        <li>Identify the environmental conditions that your solution works well in and explore how you might improve its operating tolerances.</li>
                        <li>Develop detailed documentation to accompany your demonstration that could be provided to the judges for further information.</li>
                    </ol>
                </div>

            </Modal>
            {/* 
            <Card
                hoverable
                cover={<img alt="example" src="/images/card/card-line-tracing.webp" />}
                style={{ width: 300 }}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Line Tracing Game</span>} />
                </div>
                <p className='text-sm text-gray-400 mt-2'>Robot Race Category, Team (2 Person)</p>
                <p className='text-sm text-gray-400 font-bold mt-1'>Rp250.000</p>
                <div className="grid grid-cols-2 gap-4 mt-6">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(4)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Line Tracing Game</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 4}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-2 md:ml-2 sm:ml-4 lg:ml-4'>1 team of 2 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-4 md:ml-3 md:w-1/2 '>Elementary School</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-1'>Line Tracing robot competition is to build an autonomous robot to achieve the maximum speed on the given track to reach the destination in minimum time.</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-5 lg:mr-4 md:mr-16'>Assessment Criteria</span>
                        <span className='w-full lg:w-1/2 ml-4 md:ml-3 lg:ml-2'>Speed-based</span>
                    </div>
                </div>

                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'IIT Challenge at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Universitas Kristen Krida Wacana (UKRIDA)</p>
                </div>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-4 ml-1 text-gray-500 space-y-2">
                    <li>Line Tracing robot competition is to build an autonomous robot to achieve the maximum speed on the given track to reach the destination in minimum time</li>
                    <li>The robot must follow the black line on the map, which will be released on the morning of the competition day.</li>
                    <li>The maximum size of a line tracing robot is 25cm x 25cm.</li>
                    <li>Students have to bring disassembled robots and assemble them at the venue before the game begins.</li>
                </ol>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <a className='underline' href="https://drive.google.com/file/d/1B98mHuWqjbyxPaL4a6OZO9sovk7nNPVp/view?usp=sharing">Download the Map</a>
                </div>
                <ol className="list-disc pl-4 mb-4 ml-1 text-gray-500 space-y-2">
                    <li>The “map.zip” file contains 4 distinct pieces, each measuring 160cm x 120cm.</li>
                    <li>In the context of a competition, 2 out of the 4 pieces will be chosen at random, combined, and then utilized.</li>
                    <li>The size of the combined map will be either 160cm x 240cm or 320cm x 120cm.</li>
                </ol>
                <div className="flex items-center mb-8 font-medium">
                    <FontAwesomeIcon icon={faNewspaper} style={{ color: "#00B0F0", }} className='mr-2' />
                    <a className='underline' href="https://videos.files.wordpress.com/5gYCpYbO/linetracing2_hd.original.jpg?w=697">Example Video Line Tracing</a>
                </div>
                <div className="flex items-center mb-1 font-medium">
                    <div className="flex flex-col w-full">
                        <p className='mb-6 md:mb-4 text-center text-2xl md:text-4xl text-defaultBlue font-bold'>Tips and Trick</p>
                        <p className='text-left'>Getting Started:</p>
                    </div>
                </div>
                <div className="flex flex-col ml-2 mb-8 text-gray-500">
                    <p>If you have never programmed a robot before, here’s how to get started in this competition</p>
                    <ol className="list-disc pl-4 mb-1 ml-1 mt-1 space-y-1">
                        <li>Purchase a simple robot that has line-following capabilities or build your own using an array of photosensors. These robots can be made with any other construction set. The robots must include a programmable board and light sensor array (minimum 2 sensors).</li>
                        <li>Use black insulation tape on a large white surface to provide a space to practice your robot before the competition. Start with simple lines and turns. Add complexity as you get better with deadends and loops.</li>
                        <li>Program your robot to follow the lines that you put down, by approximating the distance the robot will have to travel and using the data from the photosensors to determine when the robot is on the line and off the line, then adjust the robot’s position accordingly.</li>
                    </ol>
                    <p>Note: the robot does not need to map the course itself, it is programmed to follow the course by the team visually looking at the course.</p>
                </div>

                <div className="flex items-center mb-1 font-medium">
                    <p>Already Experienced:</p>
                </div>
                <div className="flex flex-col ml-2 text-gray-500 mb-8">
                    <p>If you already have experienced programming robots to follow lines before, here’s how you can become more competitive in this competition …</p>
                    <ol className="list-disc pl-4 mb-1 ml-1 mt-1 space-y-1">
                        <li>Optimize your programming to go faster along long straight sections of the track.</li>
                        <li>Handle turns carefully with speed and precision.</li>
                        <li>Determine the best position and number of photosensors.</li>
                        <li>Improve your robot’s performance by addressing issues like the center of gravity, traction, and turning circle.</li>
                    </ol>
                </div>
            </Modal> */}

            {/* <Card
                hoverable
                cover={<img alt="example" src="/images/card/card-mission-challenge.webp" />}
                style={{ width: 300 }}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Mission Challenge Game</span>} />
                </div>
                <p className='text-sm text-gray-400 mt-2'>Robot Race Category, Team (2 Person)</p>
                <p className='text-sm text-gray-400 font-bold mt-1'>Rp350.000</p>
                <div className="grid grid-cols-2 gap-4 mt-6">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(5)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Mission Challenge Game</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 5}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-2 md:ml-2 lg:ml-4'>1 team of 2 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-5 md:ml-3 md:w-1/2 '>Junior High School and Senior High School</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <div className="flex flex-col ml-1 md:ml-1 lg:ml-6">
                            <span className='w-full lg:w-1/2 md:ml-0 mb-2'>
                                <ol className="list-disc pl-5 space-y-2 ">
                                    <li>Mission Challenge robot competition is an advanced Line Tracing game that combines the traditional ‘Line Tracing game’ with the added mission of moving objects.</li>
                                    <li>The goal of this game is to build an autonomous robot to achieve both moving objects as requested and the maximum speed on the given track to reach the destination in minimum time.</li>
                                </ol>
                            </span>
                        </div>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-5 lg:mr-4 md:mr-16'>Assessment Criteria</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-0'>Mission completion and speed-based</span>
                    </div>
                </div>
                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'IIT Challenge at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Universitas Kristen Krida Wacana (UKRIDA)</p>
                </div>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>The robot must follow the black line on the map, which will be released on the morning of the competition day.</li>
                    <li>The maximum size of a line tracing robot is 25cm x 25cm. </li>
                    <li>Students have to bring disassembled robots and assemble them at the venue before the game begins.</li>
                    <li>The objects to move are in the form of cylinders with a diameter of 2.5 cm and a height of 8 cm.</li>
                </ol>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <a className='underline' href="https://drive.google.com/file/d/1B98mHuWqjbyxPaL4a6OZO9sovk7nNPVp/view?usp=sharing">Download the Map</a>
                </div>
                <ol className="list-disc pl-4 mb-4 ml-1 text-gray-500 space-y-2">
                    <li>The “map.zip” file contains 4 distinct pieces, each measuring 160cm x 120cm.</li>
                    <li>In the context of a competition, 2 out of the 4 pieces will be chosen at random, combined, and then utilized.</li>
                    <li>The size of the combined map will be either 160cm x 240cm or 320cm x 120cm.</li>
                </ol>
                <div className="flex items-center mb-4 font-medium">
                    <FontAwesomeIcon icon={faNewspaper} style={{ color: "#00B0F0", }} className='mr-2' />
                    <a className='underline' href="https://videos.files.wordpress.com/RBNd4di9/missionchallenge_iro_mp4_hd.original.jpg?w=720">Example Video Mission Challenges</a>
                </div>
            </Modal> */}

            <Card
                hoverable
                cover={<img alt="card-obstacle" src="/images/card/card-obstacle.webp" />}
                style={{ width: 300, display: 'flex', flexDirection: 'column' }}
            >
                <div style={{ flexGrow: 1 }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Obstacle Avoidance Driving Game</span>} />
                    <p className='text-sm text-gray-400 mt-2'>Robot Race Category, Team (2 Person)</p>
                    <p className='text-sm text-gray-400 font-bold mt-1'>Rp350.000</p>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-6">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(6)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Obstacle Avoidance Driving Game</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 6}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2 ml-1 md:ml-5 lg:ml-8'>1 team of 2 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-4 md:ml-7 md:w-1/2 '>High School (Mix Junior and Senior)</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-4'>Make a robot that avoids collision with obstacles while moving from starting position to goal in an arena.</span>
                    </div>
                </div>

                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'IIT Challenge at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Universitas Kristen Krida Wacana (UKRIDA)</p>
                </div>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Assessment</p>
                </div>
                <ol className="list-disc pl-5 space-y-2 mb-8">
                    <li>Each Team will have the opportunity to complete 3 runs of the course. The best scoring run will be used for that team’s final score.</li>
                    <li>+1 point for every second the car is on the course.</li>
                    <li>If a robot gets stuck or the team wishes to retry, the time points will be accumulated.</li>
                    <li>When a team calls a retry, the robot will be start over from the starting zone.</li>
                    <li>+1 point for every collision and +1 point for every second the robot stuck with the obstacle. If robot stuck with the obstacle after a collision for more than 5 seconds, the team must retry the course.</li>
                    <li>Points from completion time of the course and collisions during the course will be added up.</li>
                    <li>3 ultrasonic sensors have a point multiplier of 1.0, for each sensor after the third, the multiplier increases by 0.3, for each sensor under three, 0.3 is subtracted from the multiplier. </li>
                    <li>For example, if the robot with 3 ultrasonic sensors is able to complete the course in 30 seconds without collision, the car attains 30 points. If a team adds another (fourth) ultrasonic sensor, and completes the course in 30 seconds again, the team attains 39 points. Essentially, the team must achieve the goal with a time of less than 23 seconds in order to achieve the same score. Alternatively, if a team is able to complete the course in 30 seconds but with only 2 sensors, they will be awarded 21 points.</li>
                    <li>Maximum time of a robot in the arena is 5 minutes for a single attempt. An attempt is considered as a fail if the robot runs more then 5 minutes in an arena.</li>
                </ol>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faRobot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Robot Descriptions:</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>This challenge is designed to encourage innovation and experimentation with a focus on evolutionary design and improvements.</li>
                    <li>Students will have to prepare a robot car with 2 motors, 3 ultrasonic sensors, a driver controller, a chassis, a sensor shield module (optional), a microcontroller, wheels, and battery.</li>
                    <li>Robot can use max. 5 ultrasonic sensors and min. 1 ultrasonic sensor.</li>
                    <li>The maximum size of robot is 25 × 25 cm2. </li>
                    <li>The competition is open in terms of robot design and implementation. Ideally each robot needs to be capable of moving under its own power, changing the direction of travel, detecting the obstacles in its way, making the decision to either continue its path or change direction, determine a suitable alternative direction either through additional sensors or recording of data.</li>
                    <li>Microcontroller, motor driver, battery, wheels, robot chassis/frame not limited model or anything else.</li>
                    <li>Ultrasonic sensors limited to using only HC-SR04 type of sensor.</li>
                    <li>For motors, there are restrictions on the yellow DC motor.</li>
                </ol>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Arena</p>
                </div>
                <ol className="list-decimal mb-8 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>The course consists of a 2 × 2 m2 arena with an exterior wall with height of 15 cm and contains several obstacles to be avoided by the robots.</li>
                    <li>The Arena also features a 30 × 30 cm2 starting and goal areas at opposite positions within the arena.</li>
                    <li>The height of the obstacles is 15 cm. A robots ‘run’ is considered complete when it has moved from the starting zone to the goal zone..</li>
                </ol>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Mechanism</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>Each team will be tasked to complete the baseline car build and traverse an obstacle course from a starting position to a predetermined goal.</li>
                    <li>Each team will be given time 60 minutes to assembly the robot.</li>
                    <li>Robot can be tested in the arena, testing session is 30 minutes and each team is given 1 minute for a single turn. Each team can have multiple turns in this testing session.</li>
                    <li>In competition, each team is given 3 attempts. For each attempt, each car will accumulate points for the amount of time spent on the course and collisions. </li>
                    <li>Extra sensors added to the car will be accounted for extra points.</li>
                    <li>The objective for each team is to complete the challenge the least number of points.</li>
                </ol>
            </Modal>
            <Card
                hoverable
                cover={<img alt="card-sumo" src="/images/card/card-sumo.webp" />}
                style={{ width: 300, display: 'flex', flexDirection: 'column' }}
            >
                <div style={{ flexGrow: 1 }}>
                    <Meta title={<span style={{ whiteSpace: 'normal' }}>Sumo Game</span>} />
                    <p className='text-sm text-gray-400 mt-2'>Robot Race Category, Team (2 Person)</p>
                    <p className='text-sm text-gray-400 font-bold mt-1'>Rp350.000</p>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-12">
                    <div>
                        <p className='text-defaultBlue cursor-pointer mt-2' onClick={handleSeeDetail(7)}>See detail</p>
                    </div>
                    <div className="text-right">
                        <RegistrationButton />
                    </div>
                </div>
            </Card>
            <Modal
                title={
                    <div className="flex justify-between items-center">
                        <span>Sumo Game</span>
                        <div className="pr-6">
                            <RegistrationButton />
                        </div>
                    </div>
                }
                visible={activeModal === 7}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
            >
                <div className="grid grid-cols-1 gap-4 mt-4">
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-16 md:mr-24 '>Participant</span>
                        <span className='w-full md:w-1/2  ml-2 md:ml-3 lg:ml-4'>1 team of 2 people</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-14 lg:mr-14 md:mr-20 '>Study Levels</span>
                        <span className='w-full ml-4 md:ml-3 md:w-1/2 '>High School (Mix Junior and Senior)</span>
                    </div>
                    <div className="flex">
                        <span className='text-gray-400 mr-12 lg:mr-12 md:mr-24'>Challenge Type</span>
                        <span className='w-full lg:w-1/2 ml-2 md:ml-0'>Each robot has to push the opponent out of the ring, in order to win the game.</span>
                    </div>
                </div>
                <TimelineComp
                    desc={['Registration Close', 'Technical Meeting (Online)', 'IIT Challenge at Krida Wacana Christian University (UKRIDA)']}
                    dates={['14 September 2024', '21 September 2024', '05 October 2024']}
                    colors={['green', 'blue', 'purple']}
                    showTitle={true}
                />
                <div className="flex items-center mt-4 mb-8 font-medium">
                    <FontAwesomeIcon icon={faLocationDot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Universitas Kristen Krida Wacana (UKRIDA)</p>
                </div>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faRobot} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Robot Spesification</p>
                </div>
                <ol className="list-decimal pl-4 mb-8 ml-1 text-gray-500 space-y-2">
                    <li>The robot used is an RC robot. The robot is not allowed to use autonomous or semi-autonomous systems.</li>
                    <li>The robot used in the competition has maximum dimensions of 20 cm x 20 cm with unlimited height (dimensions are measured at the robot&apos;s starting position). The total robot mass including batteries is maximum 1 kg (remote not included).</li>
                    <li>The maximum battery voltage used is 12.6 V.</li>
                    <li>The voltage source must come from a Dry Accu battery (lead acid), NiCd, NiMH, Li-ion, or Li-Polymer battery.</li>
                    <li>The robot must be labelled with the name of each team on the front of the robot. The font type and size are free, but must be clearly visible to the referee.</li>
                    <li>The robot must not have devices that damage the competition arena and flip opponents by throwing.</li>
                    <li>The robot is not allowed to have devices that interfere with the performance of opponents&apos; robots such as signal jammers, strobe lights, lasers, and the like.</li>
                    <li>The robot must not have systems to attach itself to the surface of the competition arena such as suction cups, diaphragms, sticky wheels, or similar devices.</li>
                    <li>The robot must not use weapons such as projectiles or saws and must not use easily flammable devices as weapons.</li>
                    <li>During the competition, the robot must not intentionally break into several parts (break into several robots or separate robot parts).</li>
                    <li>The robot is not allowed to have devices that can increase downforce, such as vacuum pumps and magnets.</li>
                </ol>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faFlag} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Arena</p>
                </div>
                <ol className="list-decimal mb-1 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>Material: Sumo robot competition arena is made of Medium Density Fibreboard (MDF) and covered with a black rubber sheet with a thickness of 5 mm.</li>
                    <li>Dimensions: The competition arena is circular with a diameter of 77 cm and a height of 2.5 cm.</li>
                    <li>Markings: The competition arena is marked with white lines as the boundary lines on the edge of the arena, with a width of 2.5 cm. The starting line for each robot is in the center of the arena, dark red in color, with dimensions of 10 cm x 1 cm and a distance of 10 cm between them.</li>
                </ol>
                <div className="flex items-center justify-center mb-6 ml-5 font-medium text-gray-500">
                    <img src="/images/arena-pict.jpg" alt="arena-picture" />
                </div>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faBookOpen} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Rules</p>
                </div>
                <ul className="list-lower-alpha mb-6 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>During the Competition: </li>
                    <ol className="list-disc pl-4 ml-1 text-gray-500 space-y-2 mb-2">
                        <li>Material: Sumo robot competition arena is made of Medium Density Fibreboard (MDF) and covered with a black rubber sheet with a thickness of 5 mm.</li>
                        <li>Participants are expected to understand the calling sequence for the conduct of the competition based on the rundown provided by the organizers.</li>
                        <li>During the START, no external assistance to the robot is allowed, either in the form of pushing or otherwise.</li>
                        <li>Participants and teams are PROHIBITED from changing power sources and other components during the competition.</li>
                        <li>Robots must not break into several robots during the competition.</li>
                        <li>Any damage to the robot is the responsibility of the participant.</li>
                        <li>All decisions made by the organizers, referees, and judges are final and cannot be contested.</li>
                    </ol>
                    <li>After the Competition: </li>
                    <ol className="list-disc mb-1 pl-4 ml-1 text-gray-500 space-y-2">
                        <li>Participants and teams must maintain the spirit, health, and sportsmanship of the competition.</li>
                        <li>Any decision made by the organizers is final and cannot be contested.</li>
                    </ol>
                </ul>
                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faGear} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Competition Mechanism</p>
                </div>
                <ul className="list-lower-alpha mb-6 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>General Mechanism </li>
                    <ol className="list-disc pl-4 ml-1 text-gray-500 space-y-2 mb-2">
                        <li>The competition begins with group stages, with one group consisting of 4 teams. Subsequently, qualifying teams will advance to the knockout stage.</li>
                        <li>Group allocation will be determined randomly by the program during the technical meeting (TM). Furthermore, teams for the knockout stage will also be determined randomly by the program after the group stage is completed; the results of this determination are final and cannot be contested.</li>
                        <li>During the competition, the robot is operated by a handler and assisted by an assistant (both from the participating team). Only these individuals are allowed to approach the competition arena. Handler changes are permitted during breaks between rounds. </li>
                        <li>Teams not competing are allowed to watch but must remain in a sterile area and are not allowed to interfere with competing teams.</li>
                        <li>Teams not competing are advised to deactivate the remote (controller) to avoid potential interference with the competition.</li>
                        <li>If two robots are locked together or fall simultaneously for 15 seconds during the match, the match will be stopped, and the robots will be returned to their original positions. The match will then continue until time expires.</li>
                        <li>The organizers will provide a preparation time of 1 minute before each match. Preparation is done in a sterile area.</li>
                        <li>Each team is allowed one 30-second timeout per match. Timeouts are given after each round and are only given to participants who request them from the referee; robots from participants who do not request timeouts must remain in the competition arena.</li>
                        <li>Battery and component replacements are not allowed during timeouts.</li>
                        <li>Decisions made by the judges cannot be contested.</li>
                    </ol>
                    <li>Group Stage Competition Mechanism </li>
                    <ol className="list-disc mb-1 pl-4 ml-1 text-gray-500 space-y-2">
                        <li>One match consists of 3 rounds lasting a total of 5 minutes.</li>
                        <li>The match ends when one team wins 2 out of 3 rounds.</li>
                        <li>A round ends when one team scores or when the match time expires.</li>
                        <li>There are no timeouts for the group stage.</li>
                        <li>The teams that advance from the group stage are the top 2 teams with the highest points.</li>
                        <li>In case of a tie in points, the order is determined by: Win time, the time taken to score; Survive time, the time spent in the arena before being defeated/overthrown.</li>
                    </ol>
                    <li>Knockout Stage Competition Mechanism</li>
                    <ol className="list-disc mb-1 pl-4 ml-1 text-gray-500 space-y-2">
                        <li>For teams that have advanced from each round, a redraw will be conducted to determine the opponent for the next round.</li>
                        <li>One match consists of 3 rounds lasting a total of 5 minutes.</li>
                        <li>The match ends when one team wins 2 out of 3 rounds.</li>
                        <li>A round ends when one team scores or when the match time expires.</li>
                        <li>The winner is determined by the number of points.</li>
                        <li>If the points are tied, the winner is the team with the fastest time in defeating the opponent in the previous 2 rounds. If both teams have no points, neither advance to the next round.</li>
                    </ol>
                </ul>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Assessment</p>
                </div>
                <ol className="list-decimal mb-6 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>A robot that successfully pushes the opponent out of the arena or causes the opponent to touch the floor last will be awarded one point.</li>
                    <li>If no robot exits the arena, then neither team receives points.</li>
                    <li>If a robot does not collide with the opponent within 15 seconds, the opposing team receives one point.</li>
                    <li>Survive time, the time spent in the arena before being defeated/overthrown.</li>
                    <li>Win time, the time taken to score.</li>
                </ol>

                <div className="flex items-center mb-2 font-medium">
                    <FontAwesomeIcon icon={faXmarkSquare} style={{ color: "#00B0F0", }} className='mr-2' />
                    <p>Violations and Penalties</p>
                </div>
                <ol className="list-decimal mb-6 pl-4 ml-1 text-gray-500 space-y-2">
                    <li>Participants will be DISQUALIFIED for violating the rules established by the organizers.</li>
                    <li>Participants will be DISQUALIFIED for creating disturbances during the competition.</li>
                    <li>Participants will be DISQUALIFIED if they fail to meet the competition requirements.</li>
                    <li>During the competition, if a participant does not appear by the third call, their match will be moved to the last order (this policy applies only once per round). If the participant still does not appear in the next opportunity, they will be DISQUALIFIED.</li>
                </ol>
            </Modal>
        </>
    );
};

export default Cards;
